import { Documento, ISdocumento } from "../../processo/Documento";
import { ISusuarioList, UsuarioList } from "../../usuario/UsuarioList";

export interface DocumentoFavorito {
    id: string;
    descricao: string;
    usuario: UsuarioList;
    dataHora: Date | null;
    documento: Documento;
}

export const ISdocumentoFavorito: DocumentoFavorito = {
    id: "",
    descricao: "",
    usuario: ISusuarioList,
    dataHora: null,
    documento: ISdocumento,
}
